import {Component, OnInit} from '@angular/core';
import {User, UserService} from '../../core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {TitleInfo, TitleService} from '@common-lib';
import {environment} from "environments/environment";

@Component({
  selector: 'app-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  title = 'Dashboard';
  titleParams: any = {};
  currentUser: User;
  showPluginMenu : boolean = false;

  constructor(private router: Router,
              private location: Location,
              private userService: UserService,
              private titleService: TitleService,
  ) {
  }

  ngOnInit() {
    this.userService.currentUser.subscribe((userData) => {
      this.currentUser = userData;
    });
    this.titleService.title.subscribe((titleInfo: TitleInfo) => {
      this.title = titleInfo.title;
      this.titleParams = titleInfo.params;
    });

    this.showPluginMenu = environment.plugin_gotenehus_on;
  }

  logout(e) {
    e.preventDefault();
    this.userService.purgeAuth();
    this.router.navigate(['/login']);
  }

  navigateTo(url, event) {
    event.preventDefault();
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header.component.ts